import React from "react"
import { Flex } from "@chakra-ui/react"
import { Icon } from "../../"

export default function PackageIcon() {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      color="text.d100"
      bg="primary.200"
      minH="20px"
      minW="20px"
      pt="2px"
      mr={3}
    >
      <Icon name="checkmark" boxSize={4} />
    </Flex>
  )
}
